import { render } from "./FragmentHeader.vue?vue&type=template&id=78174d04"
import script from "./FragmentHeader.vue?vue&type=script&lang=js"
export * from "./FragmentHeader.vue?vue&type=script&lang=js"

import "./FragmentHeader.vue?vue&type=style&index=0&id=78174d04&lang=scss"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__